import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpandSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconExpandSimple"><Path fillRule="evenodd" clipRule="evenodd" d="M12 5.75C12 5.33579 12.3358 5 12.75 5H18.25C18.6642 5 19 5.33579 19 5.75V11.25C19 11.6642 18.6642 12 18.25 12C17.8358 12 17.5 11.6642 17.5 11.25V6.5H12.75C12.3358 6.5 12 6.16421 12 5.75ZM5.75 12C6.16421 12 6.5 12.3358 6.5 12.75V17.5H11.25C11.6642 17.5 12 17.8358 12 18.25C12 18.6642 11.6642 19 11.25 19H5.75C5.33579 19 5 18.6642 5 18.25V12.75C5 12.3358 5.33579 12 5.75 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpandSimple;
